//import uuid v4

const pizza = [
  {
    uid: "p1",
    name: "Paproni Pizza",
    price: "100",
    src: "/pizza.svg",
  },
  {
    uid: "p2",

    name: "Mozirella Pizza",
    price: "120",
    src: "/pizza.svg",
  },
  {
    uid: "p3",

    name: "Cheessy Pizza",
    price: "130",
    src: "/pizza.svg",
  },
  {
    uid: "p4",

    name: "Spicy Pizza",
    price: "140",
    src: "/pizza.svg",
  },
  {
    uid: "p5",

    name: "Veggie Pizza",
    price: "150",
    src: "/pizza.svg",
  },
];

const burger = [
  {
    uid: "b1",
    name: "Paproni burger",
    price: "100",
    src: "/burger.png",
  },
  {
    uid: "b2",
    name: "Mozirella burger",
    price: "120",
    src: "/burger.png",
  },
  {
    uid: "b3",
    name: "Cheessy burger",
    price: "130",
    src: "/burger.png",
  },
  {
    uid: "b4",
    name: "Spicy burger",
    price: "140",
    src: "/burger.png",
  },
  {
    uid: "b5",
    name: "Veggie burger",
    price: "150",
    src: "/burger.png",
  },
];
const fries = [
  {
    uid: "f1",
    name: "Paproni fries",
    price: "100",
    src: "/fries.svg",
  },
  {
    uid: "f2",
    name: "Mozirella fries",
    price: "120",
    src: "/fries.svg",
  },
  {
    uid: "f3",
    name: "Cheessy fries",
    price: "130",
    src: "/fries.svg",
  },
  { uid: "f4", name: "Spicy fries", price: "140", src: "/fries.svg" },
  { uid: "f5", name: "Veggie fries", price: "150", src: "/fries.svg" },
];

export { pizza, burger, fries };
